import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.15 25.82h7.7c.63 0 1.15-.56 1.15-1.25v-2.19H10v2.19c0 .69.51 1.25 1.15 1.25zM15 23.3c.41 0 .74.36.74.8 0 .44-.33.8-.74.8s-.74-.36-.74-.8c0-.44.33-.8.74-.8zM20 7.07c0-.69-.52-1.25-1.15-1.25h-7.7c-.64 0-1.15.56-1.15 1.25v.49h10v-.49zM13.13 8.19 10 12.14v2.28l4.74-6.23zM10 8.19v3.06l2.32-3.06zM20 8.19h-4.45L10 15.3v6.46h10z" }, null, -1)
  ])))
}
export default { render };